import { render, staticRenderFns } from "./ApplicantsKorolevView.vue?vue&type=template&id=3f68430e&scoped=true&"
import script from "./ApplicantsKorolevView.vue?vue&type=script&lang=js&"
export * from "./ApplicantsKorolevView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f68430e",
  null
  
)

export default component.exports